import Cookies from 'js-cookie'
import { CommonService } from '@/api'
import { parseTime } from '@/utils'
const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false,
  },
  ifShowMenu: true,
  device: 'desktop',
  showNotCertifi: false,
  commonData: {},
  pageLoading: false,
  certificationObj: {
    merchantDto: {}
  },
  certificationPendingStatus: ['step_4', 'pending_cmm_assigned', 'platformself_approved', 'platformself_rejected', 'pending_ys_approved'], //'finished', 'ys_rejected'

  // commonMessageList: []
}

const mutations = {
  // TOGGLE_SIDEBAR: state => {
  //   state.sidebar.opened = !state.sidebar.opened
  //   state.sidebar.withoutAnimation = false
  //   if (state.sidebar.opened) {
  //     Cookies.set('sidebarStatus', 1)
  //   } else {
  //     Cookies.set('sidebarStatus', 0)
  //   }
  // },
  // CLOSE_SIDEBAR: (state, withoutAnimation) => {
  //   Cookies.set('sidebarStatus', 0)
  //   state.sidebar.opened = false
  //   state.sidebar.withoutAnimation = withoutAnimation
  // },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  // 切换左边菜单是否展示
  TOGGLE_MENU: (state, ifShowMenu) => {
    state.ifShowMenu = ifShowMenu
  },
  // 切换未认证弹框是否展示
  TOGGLE_NOTCERTIFI: (state, showNotCertifi) => {
    state.showNotCertifi = showNotCertifi
  },
  SET_COMMOM_DATA: (state, data) => {
    state.commonData = data
  },
  TOGGLE_LOADING: (state, ifshow) => {
    state.pageLoading = ifshow
  },
  // SET_MESSAGE_LIST: (state, list) => {
  //   state.commonMessageList = list
  // }
}

const actions = {
  // toggleSideBar({ commit }) {
  //   commit('TOGGLE_SIDEBAR')
  // },
  // closeSideBar({ commit }, { withoutAnimation }) {
  //   commit('CLOSE_SIDEBAR', withoutAnimation)
  // },
  toggleDevice({ commit }, device) {
    ('TOGGLE_DEVICE', device)
  },
  toggleMenu({ commit }, ifShowMenu) {
    commit('TOGGLE_MENU', ifShowMenu)
  }
  // getCommonData({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     CommonService.getCommonData().then(response => {
  //       commit('SET_COMMOM_DATA', response.data)
  //       resolve(response)
  //     }).catch(error => {
  //       reject(error)
  //     })
  //   })
  // }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
